import { useUndo } from 'context';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SnackbarContent } from 'app/components/snackbars';

interface Props {
  description: string;
  onUndo: () => void;
}

export function UndoSnackbarContent({ description, onUndo }: Props) {
  const { isUndoLoading } = useUndo();
  const { t } = useTranslation();

  return (
    <SnackbarContent
      description={description}
      action={{
        label: t('undo_snackbar_content.button'),
        disabled: isUndoLoading,
        onClick: onUndo,
      }}
    />
  );
}
